import React from "react";
import { FaBell, FaCheckCircle } from "react-icons/fa";

function SubscriptionRenewalAlert({ stats }) {
  const hasAlerts = stats.alerts > 0;

  if (!hasAlerts) {
    return (
      <section className="rounded-[2rem] border border-emerald-200 bg-emerald-50 p-5 dark:border-emerald-500/20 dark:bg-emerald-500/10">
        <div className="flex items-start gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200">
            <FaCheckCircle />
          </div>

          <div>
            <h2 className="font-titre text-xl font-bold text-emerald-950 dark:text-emerald-100">
              Aucun renouvellement urgent
            </h2>

            <p className="mt-1 text-sm font-medium leading-6 text-emerald-700 dark:text-emerald-100/70">
              Tous les abonnements réglés semblent à jour selon la règle actuelle
              d’un an après la date d’achat.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="rounded-[2rem] border border-amber-200 bg-amber-50 p-5 dark:border-amber-500/20 dark:bg-amber-500/10">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-amber-700 dark:bg-amber-500/10 dark:text-amber-200">
          <FaBell />
        </div>

        <div>
          <h2 className="font-titre text-xl font-bold text-amber-950 dark:text-amber-100">
            Abonnements à surveiller
          </h2>

          <p className="mt-1 text-sm font-medium leading-6 text-amber-800 dark:text-amber-100/75">
            {stats.dueSoon} abonnement(s) arrivent bientôt à échéance,{" "}
            {stats.expired} sont expirés et {stats.unpaid} ne sont pas réglés.
          </p>
        </div>
      </div>
    </section>
  );
}

export default SubscriptionRenewalAlert;